import React from 'react';
import { Link } from 'react-router-dom';
import csomagszallitasImg from '../img/csomagszallitas.png';
import logo from '../img/logo.png';
import '../App.css';

const QUOTE_KEA_PATH = '/ajanlat/ikea-hazhozszallitas';

function IconCart() {
  return (
    <svg className="svc-ikea-step-icon-svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path
        d="M8 10h4l2.5 18h22l3-14H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="20" cy="40" r="2.5" fill="currentColor" />
      <circle cx="34" cy="40" r="2.5" fill="currentColor" />
    </svg>
  );
}

function IconMoney() {
  return (
    <svg className="svc-ikea-step-icon-svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <rect x="8" y="14" width="32" height="22" rx="3" stroke="currentColor" strokeWidth="2" />
      <path
        d="M24 18v14M20 22c0-2 1.8-3.5 4-3.5s4 1.5 4 3.5-1.8 3.5-4 3.5-4-1.5-4-3.5z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function IconTruckPin() {
  return (
    <svg className="svc-ikea-step-icon-svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path
        d="M6 28h4v8H6v-8zm4 0h14V14H6v14h4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20 28h10l4 4v4H20v-8z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="14" cy="36" r="2.5" fill="currentColor" />
      <circle cx="30" cy="36" r="2.5" fill="currentColor" />
      <path
        d="M34 18v6h4l2 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="38" cy="15" r="3.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="38" cy="15" r="1.2" fill="currentColor" />
    </svg>
  );
}

const IKEA_FLOW_STEPS = [
  {
    num: '01',
    Icon: IconCart,
    label: 'Termék kiválasztása',
    tip: 'Válaszd ki a megvásárolni kívánt terméket!',
  },
  {
    num: '02',
    Icon: IconMoney,
    label: 'Fizetés az áruházban',
    tip: 'Fizesd ki az áruházban az ott elérhető módokon!',
  },
  {
    num: '03',
    Icon: IconTruckPin,
    label: 'Egyeztetés az IKEA-ban',
    tip: 'Egyeztess a várható szállíthatóságról az IKEA-ban!',
  },
  {
    num: '04',
    Icon: null,
    label: 'Szállítás megrendelése',
    tip: null,
    logo: true,
  },
];

const QUOTE_ITEMS = [
  'a szállítani kívánt bútordarabok típusa és mennyisége',
  'a pontos méretek (hossz/szélesség/magasság) és súly',
  'az áruház (IKEA/Möbelix/XXXLutz) és a kiszállítási cím',
  'szükséges-e szétszerelés, illetve van-e ajtó/lift/emelet információ',
  'bármilyen különleges igény (törékeny felület, értékes darab)',
];

export default function IkeaHazhozszallitasPage() {
  const [openStepIdx, setOpenStepIdx] = React.useState(null);
  const stepsBlockRef = React.useRef(null);

  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setOpenStepIdx(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  React.useEffect(() => {
    if (openStepIdx === null) return undefined;
    const onPointerDown = (e) => {
      const root = stepsBlockRef.current;
      if (root && !root.contains(e.target)) setOpenStepIdx(null);
    };
    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [openStepIdx]);

  return (
    <main className="svc-page">
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <nav className="svc-breadcrumb-trail" aria-label="Útvonal">
            <Link className="svc-breadcrumb-seg" to="/" state={{ scrollTo: 'szolgaltatas' }}>
              Szolgáltatások
            </Link>
            <span className="svc-breadcrumb-sep" aria-hidden="true">
              /
            </span>
            <span className="svc-breadcrumb-current" aria-current="page">
              IKEA házhozszállítás
            </span>
          </nav>

          <div className="svc-hero-grid">
            <div className="svc-hero-text">
              <h1>BÚTORSZÁLLÍTÁS BÚTORÜZLETBŐL</h1>
              <p>
                <strong>(IKEA, Möbelix, XXXLutz bútorszállítás)</strong> olyan szolgáltatás, amely hasznos
                lehet mindazok számára, akik:
                <br />
                <br />
                - távol élnek a fővárosi IKEA bútoráruházaktól, vagy
                <br />
                - akik nagyméretű bútort vásárolnak valamelyik IKEA áruházban, de nincs akkora
                méretű járművük, amibe befér, vagy
                <br />
                - akiknek nincs idejük a bútoráruházban vásárolt termékekért elmenni és az
                irodájukba, üzletükbe vagy legtöbbször hazaszállítani.
              </p>
              <Link className="primary-btn svc-hero-cta" to={QUOTE_KEA_PATH}>
                Ajánlatot kérek
              </Link>
            </div>

            <div className="svc-hero-media">
              <img src={csomagszallitasImg} alt="Bútorszállítás – bútorok és nagyobb tételek szállítása" />
            </div>
          </div>
        </div>
      </section>

      <section className="svc-ikea-steps" aria-labelledby="ikea-steps-title">
        <div className="svc-ikea-steps-inner" ref={stepsBlockRef}>
          <h2 id="ikea-steps-title" className="svc-ikea-steps-title">
            IKEA szállítás megrendelés menete:
          </h2>
          <p className="svc-ikea-steps-sub">
            Vidd az egeret a lépés fölé, koppints rá érintőképernyőn, vagy használd a Tab billentyűt –
            megjelenik a részletes útmutató.
          </p>
          <ol className="svc-ikea-steps-grid">
            {IKEA_FLOW_STEPS.map((step, idx) => {
              const tipId = `ikea-step-tip-${idx}`;
              const isOpen = openStepIdx === idx;
              const IconComp = step.Icon;
              return (
                <li
                  key={step.num}
                  className={`svc-ikea-step${isOpen ? ' svc-ikea-step--open' : ''}`}
                >
                  <button
                    type="button"
                    className="svc-ikea-step-trigger"
                    aria-label={step.label}
                    aria-expanded={isOpen}
                    aria-controls={tipId}
                    onClick={() => setOpenStepIdx((p) => (p === idx ? null : idx))}
                  >
                    <span className="svc-ikea-step-watermark" aria-hidden="true">
                      {step.num}
                    </span>
                    <span className="svc-ikea-step-icon-slot">
                      {step.logo ? (
                        <span className="svc-ikea-step-icon svc-ikea-step-icon--logo">
                          <img src={logo} alt="" width={64} height={64} decoding="async" />
                        </span>
                      ) : (
                        IconComp && (
                          <span className="svc-ikea-step-icon" aria-hidden="true">
                            <IconComp />
                          </span>
                        )
                      )}
                    </span>
                  </button>
                  <div id={tipId} className="svc-ikea-step-tooltip" role="tooltip">
                    {step.logo ? (
                      <p className="svc-ikea-step-tooltip-p">
                        Rendeld meg a szállítást tőlünk! Használd az{' '}
                        <Link className="svc-ikea-step-tooltip-link" to={QUOTE_KEA_PATH}>
                          ajánlatkérő űrlapot
                        </Link>
                        .
                      </p>
                    ) : (
                      <p className="svc-ikea-step-tooltip-p">{step.tip}</p>
                    )}
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </section>

      <section className="svc-band svc-band--white" aria-label="IKEA árlista">
        <div className="elementor-container">
          <div className="elementor-column elementor-col-50 elementor-top-column">
            <div className="svc-ikea-table-block">
              <h2 className="svc-ikea-title qf-sr-only">
                Szállítási Zónaárak (Körméreten belüli termékekre)
              </h2>
              <div className="svc-ikea-table-wrap">
                <table className="wp-block-table svc-ikea-table" aria-label="Szállítási Zónaárak">
                  <tbody>
                    <tr>
                      <th colspan="3">
                        <h6>Szállítási Zónaárak (Körméreten belüli termékekre)</h6>
                      </th>
                    </tr>
                    <tr>
                      <td rowSpan="6">
                        Budapest és környéke<br />
                        (+15 km belül)
                      </td>
                      <td>0-30 kg</td>
                      <td>6 500 Ft</td>
                    </tr>
                    <tr>
                      <td>30,01 – 80 kg</td>
                      <td>11 000 Ft</td>
                    </tr>
                    <tr>
                      <td>80,01 – 200 kg</td>
                      <td>18 500 Ft</td>
                    </tr>
                    <tr>
                      <td>200,01 kg – fölött</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                    <tr>
                      <td>Budaörsi áruházból</td>
                      <td>2 500 Ft</td>
                    </tr>
                    <tr>
                      <td>Körméreten kívül</td>
                      <td>egyedi ajánlat</td>
                    </tr>

                    <tr>
                      <td rowSpan="5">1. zóna 70 km</td>
                      <td>0-30 kg</td>
                      <td>11 000 Ft</td>
                    </tr>
                    <tr>
                      <td>30,01 – 80 kg</td>
                      <td>15 000 Ft</td>
                    </tr>
                    <tr>
                      <td>80,01 – 200 kg</td>
                      <td>24 000 Ft</td>
                    </tr>
                    <tr>
                      <td>200,01 kg – fölött</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                    <tr>
                      <td>Körméreten kívül</td>
                      <td>egyedi ajánlat</td>
                    </tr>

                    <tr>
                      <td rowSpan="5">2. Zóna 100 km</td>
                      <td>0-30 kg</td>
                      <td>14 000 Ft</td>
                    </tr>
                    <tr>
                      <td>30,01 – 80 kg</td>
                      <td>18 500 Ft</td>
                    </tr>
                    <tr>
                      <td>80,01 – 200 kg</td>
                      <td>26 000 Ft</td>
                    </tr>
                    <tr>
                      <td>200,01 kg – fölött</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                    <tr>
                      <td>Körméreten kívül</td>
                      <td>egyedi ajánlat</td>
                    </tr>

                    <tr>
                      <td rowSpan="5">3. Zóna 150 km</td>
                      <td>0-30 kg</td>
                      <td>19 500 Ft</td>
                    </tr>
                    <tr>
                      <td>30,01 – 80 kg</td>
                      <td>25 000 Ft</td>
                    </tr>
                    <tr>
                      <td>80,01 – 200 kg</td>
                      <td>34 000 Ft</td>
                    </tr>
                    <tr>
                      <td>200,01 kg – fölött</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                    <tr>
                      <td>Körméreten kívül</td>
                      <td>egyedi ajánlat</td>
                    </tr>

                    <tr>
                      <td rowSpan="5">4. zóna 250 km</td>
                      <td>0-30 kg</td>
                      <td>28 000 Ft</td>
                    </tr>
                    <tr>
                      <td>30,01 – 80 kg</td>
                      <td>31 500 Ft</td>
                    </tr>
                    <tr>
                      <td>80,01 – 200 kg</td>
                      <td>45 000 Ft</td>
                    </tr>
                    <tr>
                      <td>200,01 kg – fölött</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                    <tr>
                      <td>Körméreten kívül</td>
                      <td>egyedi ajánlat</td>
                    </tr>

                    <tr>
                      <td rowSpan="2">5. zóna &gt; 250 km</td>
                      <td>Minden súlyra</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                    <tr>
                      <td>Körméreten kívül</td>
                      <td>egyedi ajánlat</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="elementor-column elementor-col-50 elementor-top-column">
            <div className="svc-ikea-table-block">
              <h3 className="svc-ikea-subtitle qf-sr-only">Szállítmány érték felár</h3>
              <div className="svc-ikea-table-wrap">
                <table className="wp-block-table svc-ikea-table" aria-label="Szállítmány érték felár">
                  <tbody>
                    <tr>
                      <th colspan="2">
                        <h6>Szállítmány érték felár</h6>
                      </th>
                    </tr>
                    <tr>
                      <td>1-100.000 Ft</td>
                      <td>nincs</td>
                    </tr>
                    <tr>
                      <td>100.001-200.000 Ft</td>
                      <td>6 000 Ft</td>
                    </tr>
                    <tr>
                      <td>201.000-400.000 Ft</td>
                      <td>9 000 Ft</td>
                    </tr>
                    <tr>
                      <td>401.000 Ft-tól</td>
                      <td>15 000 Ft</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="svc-ikea-table-block">
              <h3 className="svc-ikea-subtitle qf-sr-only">Tervezett útvonalak</h3>
              <div className="svc-ikea-table-wrap">
                <table className="wp-block-table svc-ikea-table" aria-label="Tervezett útvonalak">
                  <tbody>
                    <tr>
                      <th colspan="3">
                        <h6>Tervezett útvonalak</h6>
                      </th>
                    </tr>
                    <tr>
                      <td>1. keleti kör</td>
                      <td>HÉTFŐ</td>
                      <td>
                        Budapest – Hatvan – Gyöngyös –<br />
                        Eger – Debrecen – Nyíregyháza –<br />
                        Berettyóújfalu – Miskolc
                      </td>
                    </tr>
                    <tr>
                      <td>2. dél-nyugati kör</td>
                      <td>KEDD</td>
                      <td>
                        Budapest – Székesfehérvár – Veszprém –<br />
                        Ajka – Zalaegerszeg – Nagykanizsa –<br />
                        Kaposvár – Pécs – Szekszárd
                      </td>
                    </tr>
                    <tr>
                      <td>3. dél-keleti kör</td>
                      <td>SZERDA</td>
                      <td>
                        Budapest – Kecskemét –<br />
                        Kiskunfélegyháza – Kiskunhalas –<br />
                        Szentes – Hódmezővásárhely –<br />
                        Szeged – Békéscsaba – Szolnok
                      </td>
                    </tr>
                    <tr>
                      <td>4. dél-nyugati kör</td>
                      <td>CSÜTÖRTÖK</td>
                      <td>
                        Budapest – Győr –<br />
                        Mosonmagyaróvár – Sopron –<br />
                        Szombathely – Pápa
                      </td>
                    </tr>
                    <tr>
                      <td>5. budapesti kör</td>
                      <td>PÉNTEK</td>
                      <td>
                        Budapest és 15 km-es<br />
                        vonzáskörzete
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="svc-ikea-note">
                Az útvonalak napi beosztása tájékoztató jellegű, de ha ettől eltérő igényed van, ajánlatkéréskor kérlek jelezd.
                A valós szállítási napok a rendelések mennyisége, és szállítások területi megoszlása függvényében változhat.
                Minden esetben érdeklődj emailben, vagy telefonon!
              </p>
            </div>

            <div className="svc-ikea-table-block">
              <h3 className="svc-ikea-subtitle qf-sr-only">Üzleten belüli összegyűjtés árai (nettó)</h3>
              <div className="svc-ikea-table-wrap">
                <table className="wp-block-table svc-ikea-table" aria-label="Üzleten belüli összegyűjtés árai (nettó)">
                  <tbody>
                    <tr>
                        <th colspan="3">
                        <h6>Üzleten belüli összegyűjtés árai (nettó)</h6>
                      </th>
                    </tr>
                    <tr>
                      <td>1 – 3 tétel</td>
                      <td>2 500</td>
                    </tr>
                    <tr>
                      <td>4-6 tétel</td>
                      <td>3 500</td>
                    </tr>
                    <tr>
                      <td>7-10 tétel</td>
                      <td>4 700</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--quote" aria-labelledby="ikea-quote-h">
        <div className="svc-band-inner svc-quote-layout">
          <div className="svc-quote-main">
            <h2 id="ikea-quote-h">Mi alapján készül az ajánlat?</h2>
            <p className="svc-quote-lead">A pontos ajánlathoz kérjük add meg:</p>
            <ul className="svc-bullet-list svc-bullet-list--quote">
              {QUOTE_ITEMS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <p className="svc-tip svc-tip--in-card">
              Ha tudsz, csatolj fotót a bútorokról és a csomagolóanyagról – így gyorsabban és
              pontosabban tudunk ajánlatot adni.
            </p>
          </div>

          <aside className="svc-quote-aside" aria-labelledby="ikea-quote-info-h">
            <h2 id="ikea-quote-info-h" className="svc-quote-aside-title">
              Információk:
            </h2>
            <ul className="svc-quote-info-list">
              <li>
                Kérünk, hogy a pontos árajánlathoz <strong>minden mezőt tölts ki</strong> a valóságnak
                megfelelően!
              </li>
              <li>
                A <strong>csillaggal jelölt mezők</strong> kitöltése kötelező.
              </li>
              <li>
                Áraink <strong>nettó árak</strong>. Az Áfát nem tartalmazzák!
              </li>
              <li>
                Az árajánlat elküldését követően <strong>1–5 napon belül</strong> tudjuk a pontos
                árajánlatot kiküldeni.
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section className="svc-band svc-band--dark">
        <div className="svc-band-inner svc-closing">
          <h2>Bútorüzletből vagy webshopból vásárolt termékeket szállíttatsz?</h2>
          <p>
            Írd meg a legfontosabb adatokat, és segítünk a legjobb kiszállítási megoldást
            megtervezni.
          </p>
          <Link className="primary-btn svc-closing-btn" to={QUOTE_KEA_PATH}>
            Ajánlatot kérek
          </Link>
        </div>
      </section>

      <section className="svc-band svc-band--white svc-gyik-band">
        <div className="svc-band-inner svc-gyik-row">
          <p className="svc-gyik-text">
            Ha valami kérdésed maradt még, email vagy telefon előtt keresd a GYIK-ben.
            <br />
            Biztos rátalálsz a válaszra.
          </p>
          <Link className="svc-gyik-link" to="/gyik">
            Tovább a GYIK-hez →
          </Link>
        </div>
      </section>
    </main>
  );
}

